module.exports = __webpack_public_path__ + "static/3-3647ec20f8d67a28217fe86150332e7f.jpg";